module.exports = __webpack_public_path__ + "media/images/tutorial_header_pc1-01-40d8b7708ac48bc38b38cdd6c90fc2ff.png";